var map = {
	"./goldcoin/airdrop-channel.png": 29221,
	"./memetown/airdrop-channel.png": 65003,
	"./reflection/airdrop-channel.png": 22647,
	"./tapcoin/airdrop-channel.png": 85745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27845;